import React, { useEffect, useState } from "react";
import axios from "axios";
import { REACT_APP_API_URL } from "../../../../env";

const OrgStructureList = ({ onAction }) => {
  const [rows, setRows] = useState([]);

  const load = async () => {
    const res = await axios.get(`${REACT_APP_API_URL}api/dashboard/admin/getOrgStructure`);
    const all = [
      ...res.data.chief,
      ...res.data.minister,
      ...res.data.departmentHeads,
      ...res.data.jtdcHeads
    ];
    setRows(all);
  };

  useEffect(() => { load(); }, []);

  return (
    <table className="table table-bordered">
      <thead>
        <tr>
          <th>ID</th>
          <th>Name</th>
          <th>Section</th>
          <th width="260">Actions</th>
        </tr>
      </thead>
      <tbody>
        {rows.map(r => (
          <tr key={r.OrgID}>
            <td>{r.OrgID}</td>
            <td>{r.PersonName}</td>
            <td>{r.SectionCode}</td>
            <td className="d-flex gap-2">
              <button className="btn btn-primary btn-sm"
                onClick={() => onAction("view", r)}>View</button>

              <button className="btn btn-warning btn-sm"
                onClick={() => onAction("edit", r)}>Edit</button>

              <button className="btn btn-danger btn-sm"
                onClick={() => onAction("delete", r)}>Delete</button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default OrgStructureList;
